// Components, Layouts, Pages
import {
  CourseDetailPageStudent,
  DashboardPageStudent,
  DiscussionDetailPageStudent,
  EducationalProgramPageStudent,
  QuizDetailPageStudent,
  TuitionFeesPageStudent,
  QuizTakingPageStudent,
  MaterialArchivePageStudent,
} from '~/pages/student';
import { IRouteModel } from '~/utils/interface/base';
// Others
// Styles, images, icons

export const studentRoute = {
  base: '/student',
  dashboard: '/dashboard',
  course: '/course',
  tuitionArea: '/tuition-area',
  examArea: '/exam-area',
  materials: '/materials',
  module: '/module',
  discussion: '/discussion',
  quiz: '/quiz',
  takeQuiz: '/take',
  courseDetail: '/:courseId',
  moduleDetail: '/:moduleId',
  discussionDetail: '/:discussionId',
  quizDetail: '/:quizId',

  // Common
  commonCreate: '/create',
  commonDetail: '/:id',
};

export const privateStudentRoutes: IRouteModel[] = [
  {
    index: true,
    path: `${studentRoute.base}`,
    component: DashboardPageStudent,
    name: 'Dashboard',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.dashboard}`,
    component: DashboardPageStudent,
    name: 'Dashboard',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.course}${studentRoute.courseDetail}${studentRoute.module}${studentRoute.moduleDetail}`,
    component: CourseDetailPageStudent,
    name: 'CourseDetail',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.tuitionArea}`,
    component: TuitionFeesPageStudent,
    name: 'TuitionFees',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.materials}`,
    component: MaterialArchivePageStudent,
    name: 'MaterialArchive',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.examArea}`,
    component: EducationalProgramPageStudent,
    name: 'EducationalProgram',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.course}${studentRoute.courseDetail}${studentRoute.discussion}${studentRoute.discussionDetail}`,
    component: DiscussionDetailPageStudent,
    name: 'DiscussionDetail',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.course}${studentRoute.courseDetail}${studentRoute.quiz}${studentRoute.quizDetail}`,
    component: QuizDetailPageStudent,
    name: 'QuizDetail',
  },
  {
    index: true,
    path: `${studentRoute.base}${studentRoute.course}${studentRoute.courseDetail}${studentRoute.quiz}${studentRoute.quizDetail}${studentRoute.takeQuiz}`,
    component: QuizTakingPageStudent,
    name: 'QuizTaking',
  },
];

export const studentRouteAbsolute = {
  dashboard: `${studentRoute.base}`,
};
